import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
// Placeholder imports for images - replace with correct paths
import MRI from "../../assets/images/home-page/MRI.jpg";
import mamography from "../../assets/images/home-page/3dMamography.jpg";
import cardiac from "../../assets/images/home-page/cardiacImagingHome.jpg";
import ct_scan from "../../assets/images/home-page/ct_scan.JPG"
const Equipment = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const updateSlidesToShow = () => {
      if (window.innerWidth <= 640) {
        setSlidesToShow(1);
      } else if (window.innerWidth <= 920) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    updateSlidesToShow();
    window.addEventListener("resize", updateSlidesToShow);
    return () => window.removeEventListener("resize", updateSlidesToShow);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow,
    responsive: [
      {
        breakpoint: 920,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 },
      },
    ],
  };
  const items = [
    {
      title: "High-Field/Open MRI",
      description:
        "Safe and non-invasive imaging capturing the finest anatomical details.",
      image: MRI,
      link: "/services/tests/open-mri-scan",
    },
    {
      title: "2D/3D Mammography",
      description:
        "Earlier detection of breast cancer with accuracy for advanced breast imaging.",
      image: mamography,
      link: "/services/tests/3D-mammography",
    },
    {
      title: "PET/CT",
      description:
        "High-resolution images of the entire body that often get missed by other diagnoses.",
      image: ct_scan,
      link: "/services/tests/pet-ct-scan",
    },
    {
      title: "Cardiac Imaging",
      description:
        "Early detection of heart diseases by monitoring every heartbeat in detail.",
      image: cardiac,
      link: "/services/subspecialities/cardiac-imaging",
    },
  ];

  return (
    <section className="py-12 font-robout">
      <div className="">
        <h2 className="text-[#d78558] font-robout text-[2rem] sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-[4rem] tracking-[-0.04em] leading-tight text-center pt-24 sm:pt-32 font-black">
          Our Specialized Services
        </h2>

        {/* Subheading */}
        <p className="pb-6 pt-6 sm:pt-8 text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[2.25rem] px-8 text-white text-center font-robout leading-snug">
          Technology You Can Trust. Care You Can Feel.
        </p>

        {/* Description */}
        <div className="flex justify-center">
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-2xl px-4 text-white text-center leading-relaxed sm:leading-relaxed lg:leading-relaxed max-w-4xl">
            Each diagnostic scan at CDC blends precision imaging with a Board
            Certified Radiologist’s supervision, ensuring accurate results and
            the reassurance you deserve.
          </p>
        </div>
        <div className="w-full sm:max-w-[80%] mx-auto px-2 mt-16">
          <Slider {...settings}>
            {items.map((modality, idx) => (
              <div
                key={idx}
                className="relative px-6"
                style={{ minHeight: 600 }}
              >
                <Link to={modality.link} aria-label={`${modality.link} `}>
                  <div
                    onMouseEnter={() => setExpandedIndex(idx)}
                    onMouseLeave={() => setExpandedIndex(null)}
                    className="relative transition-all duration-300 ease-in-out shadow-xl cursor-pointer overflow-hidden rounded-xl text-white mb-10"
                    style={{
                      height: expandedIndex === idx ? 550 : 500,
                      backgroundImage: `url(${modality.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <div
                      className="absolute bottom-0 left-0 w-full transition-all duration-300 ease-in-out p-4 bg-gradient-to-t from-black/100 to-transparent"
                      style={{
                        height: expandedIndex === idx ? "40%" : "80px",
                      }}
                    >
                      <h3 className="text-xl font-semibold ">
                        {modality.title}
                      </h3>
                      <p
                        className={`text-[17px] mt-1 transition-opacity duration-300 ${
                          expandedIndex === idx ? "opacity-100" : "opacity-0"
                        }`}
                      >
                        {modality.description}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
        <div className="flex justify-center mt-36">
          <Link
            to="/services"
            aria-label="Services"
            className="group relative inline-flex font-robout font-black tracking-wider items-center rounded-full px-8 py-4 text-lg md:text-2xl text-white bg-transparent overflow-hidden"
          >
            <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
              <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
              </span>
            </span>
            <span className="relative">
              <span className="flex flex-row gap-2 justify-center items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                View All Services
              </span>
              <span className="absolute flex flex-row gap-2 top-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                View All Services
              </span>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Equipment;

